<script setup>
import { OhVueIcon } from "oh-vue-icons";
import { ref } from 'vue';

import { store } from '../store.js';
import FormButtons from "./forms/FormButtons.ce.vue";
import FormFields from "./forms/FormFields.ce.vue";
import ModalOverlay from "./layouts/ModalOverlay.ce.vue";

const isShowModal = ref(false);

function closeModal() {
  isShowModal.value = false
}

function showModal() {
  isShowModal.value = true
}

if (window.location.hash === '#col-modal') {
  showModal();
}
</script>

<template>
  <a class="text-white" type="button" href="#" @click="showModal">
    <div class="flex flex-row">
      <OhVueIcon name="gi-receive-money" class="mr-2" width="48" scale="2" />
      <div class="flex flex-col items-start">
        <div class="mb-2">
          {{ store.translations.question_intro }}
        </div>
        <span class="underline underline-offset-4 decoration-2 hover:no-underline">
          {{ store.translations.question }}
        </span>
      </div>
    </div>
  </a>

  <ModalOverlay v-if="isShowModal" @close="closeModal">
    <template #header>
      <div class="flex items-center text-xl">
        <OhVueIcon name="gi-receive-money" class="mr-2" width="48" scale="2" />
        {{ store.translations.survey_title }}
      </div>
    </template>

    <template #body>
      <FormFields :survey="store.survey.mini" />
    </template>

    <template #footer>
      <FormButtons :show-close-modal-button="true" :survey="store.survey.mini" @close-modal="closeModal" />
    </template>
  </ModalOverlay>
</template>
